module.exports = __webpack_public_path__ + "static/img/kv.97c8fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/kv.jpg
// module id = k1sb
// module chunks = 7